import moment from 'moment';
import React, { Component } from 'react';
import Avatar from 'react-avatar';
import { adminCommentModerator } from 'entoro-shared';

export default class ReplyCard extends Component {
  render() {
    const { reply } = this.props;
    return (
      <div className='single-comment marleft'>
        <div className='single-comment-box'>
          <div className='img-holder reply_icon_marleft'>
            <Avatar
              color={Avatar.getRandomColor('sitebase', [
                'red',
                'green',
                'blue',
              ])}
              name={reply.repliedBy}
              size='50'
              round={true}
            />
          </div>
          <div className='text-holder'>
            <div className='nameHolder'>
              <h3>{`${reply.repliedBy} |`}</h3>
              {reply.commentModeratorTitle && (
                <span className='badge-investor'>
                  {adminCommentModerator.getLabel(reply.commentModeratorTitle)}
                </span>
              )}
            </div>
            <h6>{moment(reply.createdAt).fromNow()}</h6>
            <p>{reply.text}</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/Replies/ReplyCard.js